import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import {
  MetricTable,
  selectFormat,
  Error,
  sortNumeric,
} from "../Utils/Utils.js";

const metric = (cell, row, enumObject, params) => {
  const props = { ...cell, ...params };
  return <MetricTable {...props} />;
};

class LeeCustomerIoCampaign extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      expandedRows: false,
      currentRowID: null,
      rows: this.props.data.rows.map((row, id) => ({ ...row, id })),
    };
  }

  componentDidMount() {
    this.props.childRef(this);
    this.setState({
      hiddenRows: this.state.rows
        .filter((d) => d.campaign === "")
        .map((row, i) => row.id),
    });
  }

  renderChildren = (data, columns) => {
    const defaultSorted = [
      {
        dataField: "sent_unique",
        order: "desc",
      },
    ];

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns.map((column) => ({
          ...column,
          ...(column.dataField === "sent_unique" ? { sort: true } : null),
        }))}
        striped={false}
        hover={false}
        bordered={false}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
            defaultSorted={defaultSorted}
          />
        )}
      </ToolkitProvider>
    );
  };

  renderTable = (data) => {
    const { cells, title, url } = this.props;

    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "campaign_type",
        text: "Type",
        style: { width: "130px", minWidth: "130px", verticalAlign: "top" },
        csvFormatter: (cell, row) => row && row.subject,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: "",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "campaign",
        text: "Campaign",
        style: {
          width: "240px",
          minWidth: "240px",
          textAlign: "left",
        },
        headerAlign: "left",
        formatExtraData: {
          name: url.split("/")[2],
        },
        csvFormatter: (cell, row) => row && row.campaign,
        formatter: (cellContent, row) => {
          if (row.subject === "Aggregate") {
            return (
              <>
                <button className="toggleRowButton">
                  <span>{row.campaign} ↓</span>
                </button>{" "}
              </>
            );
          }
        },
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: "",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
        sort: true,
      },

      {
        dataField: "subject",
        text: "Subject",
        style: { width: "180px", minWidth: "180px", verticalAlign: "top" },
        csvFormatter: (cell, row) => row && row.subject,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: "",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "sent_unique",
        text: "Unique Sends",
        style: { width: "100px", minWidth: "120px", verticalAlign: "top" },
        formatter: metric,
        sortFunc: sortNumeric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "delivered_unique",
        text: "Unique Delivered",
        style: { width: "100px", minWidth: "100px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "delivered_rate",
        text: "Unique Delivered Rate",
        style: { width: "100px", minWidth: "140px", verticalAlign: "top" },
        formatter: metric,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
      },
      {
        dataField: "opened_unique",
        text: "Unique Opens",
        style: { width: "100px", minWidth: "100px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "open_rate",
        text: "Unique Open Rate",
        style: { width: "100px", minWidth: "120px", verticalAlign: "top" },
        formatter: metric,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
      },
      {
        dataField: "clicked_unique",
        text: "Unique Clicks",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "ctr",
        text: "CTR",
        style: { width: "80px", minWidth: "80px", verticalAlign: "top" },
        formatter: metric,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
      },
      {
        dataField: "unsubscribed_unique",
        text: "Unsubscribed Unique",
        style: { width: "120px", minWidth: "120px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "unsubscribe_rate",
        text: "Unsubscribe Rate",
        style: { width: "120px", minWidth: "120px", verticalAlign: "top" },
        formatter: metric,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
      },
    ];

    const expandRow = {
      renderer: (row, rowIndex) => {
        return this.renderChildren(
          data.filter(
            (d) => d.parent === row.parent && d.campaign.length === 0
          ),
          columns
        );
      },
    };

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) =>
        selected_columns.push(columns.find((o) => o.dataField === cell))
      );
    }
    const filename = title.split(" ").join("_") || "spreadsheet";

    const rowStyle = (row) => {
      const style = {};

      if (row.subject === "Aggregate") {
        style.backgroundColor = "#eee";
        style.cursor = "pointer";
      }

      return style;
    };

    return (
      <div className="master-detail-table">
        <ToolkitProvider
          keyField="id"
          data={data}
          columns={selected_columns}
          striped={false}
          hover={false}
          bordered={false}
          exportCSV={{
            fileName: filename + ".csv",
            exportAll: false,
            onlyExportFiltered: true,
          }}
        >
          {(props) => (
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              rowStyle={rowStyle}
              hiddenRows={this.state.hiddenRows}
              expandRow={expandRow}
              filter={filterFactory()}
              ref={(el) => (this.childRef = el)}
            />
          )}
        </ToolkitProvider>
      </div>
    );
  };

  builtInExportCSV = () => this.childRef;

  groupData = (data) => {
    let currentParent = 0;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      if (element.campaign.trim().length > 0) {
        currentParent = index + 1;
      }
      element.parent = currentParent;
    }
    return data;
  };
  render() {
    let data = this.state.rows;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    data = this.groupData(data);
    return this.renderTable(data);
  }
}

export default LeeCustomerIoCampaign;
